module.exports = __webpack_public_path__ + "assets/1d3ba27866514687a6eea00721f3963d.mp3";